import { mapGetters } from 'vuex';
export const auth ={

    computed: {
        ...mapGetters({
            newMessage:'message/getNewMessageCount'
        }),
        isAuth() {
            return this.$store.getters.isAuthenticated;
        },
        user() {
            return this.$store.getters.currentUser;
        },
        getMode()
        {
            return this.$store.state.sets.mode;
        }
    },
    mounted(){
        if(this.isAuth)
        {
            this.$store.dispatch('message/getMessageCount',{user_id:this.user.id});//새쪽지
        }

    },
    methods:{
        authCheck(mobile){
            //로그인 체크
            if(!this.isAuth)
            {
                if(confirm("로그인이 필요합니다.") ){
                    //guest는 disconnect 시키고 로그인 페이지로                 
                    this.$emit('disconnect');
                    if(mobile ==='isMobile')
                    {
                        this.$router.push({ name: 'm_Login'});
                    }else{
                        this.$router.push({ name: 'auth_login'});
                    }
                    
                    return;
                }else{
                    return;
                }
            }else{
                return true;
            }
            
        },
        async ckItem(type,pos,roomId,itemName, isMobile) {
            //type 채팅방 입장 : chat_free, 슈퍼방개설권 : chat_makeroom,홍보게시글 등록권: post_write
            const formData = {
                user_id:this.$store.getters.currentUser.id,
                item_name:type,
                room_id:roomId
                //슈퍼방개설권:chat_makeroom, 자유채팅 이용권:chat_free, 홍보게시글 등록권:post_write
            }
            let item = itemName?itemName:'';
            try {
                const response = await this.$store.dispatch("item/ckItemValidity", formData)
                if(!response[0])
                {
                    let item_id = "";
                        switch (type) 
                        {
                            case 'chat_makeroom':                                  
                                item_id ="6" ;
                                break;
                            case 'chat_free':
                                item_id ="10" ;
                                break;
                            case 'chat_mtm':                                 
                                item_id ="17" ;
                                break;
                            case 'change_nic':
                                item_id ="15" ;
                                break;    
                            default:
                                item_id="1";
                        }
                    //1:1채팅 아이템은 현재 하이드
                    if(item_id === "17") 
                    {
                        alert('1:1채팅은 현재 방장과 매니저만 가능합니다.');
                        return;
                    }
                        
                    if(confirm(item + " 아이템이 필요합니다.아이템 구매페이지로 가시겠습니까?\n 보유중일 경우 구매내역에서 추가로 사용하기를 이용해 주세요")){
                        
                        if(opener)
                        {
                            window.close();
                            opener.location.href= '/main/item/view/'+item_id;
                        }else{
                            //this.$router.push({ name: 'itemlist'});
                            //아이템에 따라 해당 아이템 구매페이지로 이동
                            if(isMobile==='isMobile')
                            {
                                this.$router.push('/m/item/view/'+item_id);
                            }else{
                                this.$router.push('/main/item/view/'+item_id);    
                            }
                            
                        }
                        this.$store.commit("menu/setActiveMenu", 'item');
                        return false;
                    }else{
                        return false;
                    }
                }else{
                    return true;
                }
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
        },
        //친구추가
        async addFriend(friend_nic, isMobile)
        {
            if(this.authCheck(isMobile) !==true)
            {
                return
            }
            const formData = {
                user_id:this.user.id,
                friend_nic:friend_nic
            }
            try {
                const response = await this.$store.dispatch("friend/addFriend", formData)

                // if(response.itemUse)
                // {
                //     this.$store.commit('updateUserPoint',response.user);
                // }
                this.$flashMessage.show({
                    type: response.status_code===201?"info":"error",
                    title: response.message,
                    message: response.message,
                });
            }catch(error){
                console.log(error);
            }
        }
    }
}
